import React, { useEffect } from "react";
import Helmet from "react-helmet";

function Closed() {
  //スクロール位置元に戻す
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>サービス休止のお知らせ |【ゼロイチ47】</title>
        <meta
          name="description"
          content="ゼロイチ47-日本を動かす共創をしよう-サービス休止のお知らせ"
        />
      </Helmet>
      <div className="closedPage">
        <p className="closedPageLogo">
          <img src={process.env.PUBLIC_URL + "/images/logo.svg"} alt="ゼロイチ47" />
        </p>
        <div className="closedPageBody">
          <h1>サービス休止のお知らせ</h1>
          <p>
            平素より「ゼロイチ47」をご利用いただき、誠にありがとうございます。
            <br />
            誠に勝手ながら、現在サービスを休止しております。
            <br />
            再開時期につきましては、決まり次第本サイトにてお知らせいたします。
          </p>
          <p>
            ご利用の皆様にはご不便をおかけいたしますが、
            <br />
            何卒ご理解賜りますようお願い申し上げます。
          </p>
          <div className="closedPageContact">
            <h2>お問い合わせ</h2>
            <p>
              <a href="mailto:info@0147.jp">info@0147.jp</a>
            </p>
          </div>
        </div>
        <p className="closedPageCopyright">
          Copyright © LOCAL VENTURE GROUP Co.,Ltd. All Rights Reserved.
        </p>
      </div>
    </>
  );
}

export default Closed;
